module.exports = __webpack_public_path__ + "img/lemon-right-1.1ba1dc32.png";